import { Directive, HostListener, ElementRef, Input } from '@angular/core';
// import { NgControl } from '@angular/forms';
@Directive({
  selector: '[appRegex]',
  standalone: true,

})
export class RegexDirective {
  @Input() regexType!: string;

  regexPattren: any;
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    switch (this.regexType) {
      case 'noSpace':
        this.regexPattren = /\s+/g;
        break;
      case 'decimalValue':
        this.regexPattren = /[^0-9.]/g;
        break;
      case 'onlyNumber':
        this.regexPattren = /[^0-9]/g;
        break;
      case 'negativeDecimal':
        this.regexPattren = /[^-0-9.]/g;
        break;
      case 'only1to9':
        this.regexPattren = /[^1-9]/g;
        break;
      default:
        break;
    }

    const numericValue = inputValue.replace(this.regexPattren, '');
    // Update the input field value with the cleaned numeric value
    inputElement.value = numericValue;
    // this.ngControl.control?.setValue(numericValue, { emitEvent: false });
  }
}
